module.exports = __webpack_public_path__ + "img/xaas-logo.70be19f.svg";